import { render, staticRenderFns } from "./IssueCoupon.vue?vue&type=template&id=120bbdbd&scoped=true&"
import script from "./IssueCoupon.vue?vue&type=script&lang=js&"
export * from "./IssueCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120bbdbd",
  null
  
)

export default component.exports